export const UPDATE_RATING_FORM_DATE_FROM = "UPDATE_RATING_FORM_DATE_FROM";
export const UPDATE_RATING_FORM_HOURLY_RATE = "UPDATE_RATING_FORM_HOURLY_RATE";
export const UPDATE_RATING_FORM_DEFAULT = "UPDATE_RATING_FORM_DEFAULT";
export const SUBMIT_RATING_FORM_ROW_UPDATE = "SUBMIT_RATING_FORM_ROW_UPDATE";
export const RATING_HIDE_UPDATE_ROW_FORM = "RATING_HIDE_UPDATE_ROW_FORM";
export const SUBMIT_RATING_FORM_ROW_UPDATE_INSERT = "SUBMIT_RATING_FORM_ROW_UPDATE_INSERT";
export const SUBMIT_RATING_FORM_GET_UPDATED_RATES = "SUBMIT_RATING_FORM_GET_UPDATED_RATES";